import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainOrderComponent } from '../main-order/main-order.component';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { VouchersRouting } from '../vouchers.routes';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FavoritesNofashimRouting } from 'app/favorites-nofashim/favorites-nofashim.routes';
import { PageNotFoundComponent } from '../Shared/page-not-found/page-not-found.component';


@NgModule({
  declarations: [
    MainOrderComponent, 
    OrderDetailsComponent,
    PageNotFoundComponent
  ],
  imports: [
    CommonModule,
    VouchersRouting,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,
    FavoritesNofashimRouting
  ]
})
export class VouchersModule { }
